import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  BooleanField,
  ReferenceField,
  ChipField,
  FunctionField,
  useTranslate,
  RaRecord,
  BulkDeleteWithConfirmButton,
  usePermissions,
} from "react-admin";
import GlobalPagination from "../common/GlobalPagination";

import domainFilters from "./domainFilters";
import { SYSTEM_ADMINISTRATOR } from "../authProvider/roles";

const DomainList = () => {
  const translate = useTranslate();
  const { permissions } = usePermissions();
  return (
    <List
      sort={{ field: "unicodeName", order: "ASC" }}
      filters={domainFilters}
      perPage={GlobalPagination.perPage}
      pagination={GlobalPagination.pagination}
    >
      <Datagrid
        rowClick="show"
        bulkActionButtons={
          <BulkDeleteWithConfirmButton mutationMode="pessimistic" />
        }
      >
        <TextField source="unicodeName" />
        <BooleanField source="isMainDomain" />
        <BooleanField source="mailEnabled" />
        <ChipField source="aliasDomainCount" textAlign="center" />
        <ChipField source="mailAccountCount" textAlign="center" />
        <ChipField source="mailForwardCount" textAlign="center" />
        <ReferenceField
          source="mainDomainId"
          reference="Domain"
          sortable={false}
          link="show"
        >
          <TextField source="domain" />
        </ReferenceField>
        <ReferenceField
          source="customerId"
          reference="Customer"
          sortable={false}
          link="show"
        >
          <TextField source="name" />
        </ReferenceField>
        <FunctionField
          source="managedBy"
          render={(record?: RaRecord) => {
            const value = record?.managedBy;
            return value
              ? translate(`resources.Domain.domainManager.${value}`)
              : "-";
          }}
        />
        {permissions === SYSTEM_ADMINISTRATOR && (
          <ReferenceField
            source="serviceBookingId"
            reference="ServiceBooking"
            sortable={false}
            link="edit"
          >
            <TextField source="amount" />x{" "}
            <ReferenceField
              source="serviceTemplateId"
              reference="ServiceTemplate"
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </ReferenceField>
        )}
        <DateField source="createdAt" />
        <DateField source="updatedAt" />
      </Datagrid>
    </List>
  );
};
export default DomainList;
